<template>
  <ValidationObserver @submit="addExamType">
    <UiModalContainer
      footer-classes="flex justify-end gap-3"
      :modal-show="modal"
      :modal-width="50"
      @handleClick="handleClick"
    >
      <template v-slot:header>
        <span>
          <span v-if="!edit">Add Exam Type</span>
          <span v-else>Edit Exam Type</span>
        </span>
      </template>
      <template v-slot>
        <div>
          <InputFieldWrapper>
            <InputBox
              v-model="examType.title"
              type="text"
              name="EXAM_TYPE"
              title="EXAM_TYPE"
              label="EXAM_TYPE"
              placeholder="EXAM_TYPE"
              rules="required"
            />

            <InputBox
              v-model="examType.description"
              type="text"
              name="Description"
              title="Description"
              label="Description"
              placeholder="Description"
            />
          </InputFieldWrapper>
        </div>
      </template>
      <template v-slot:footer>
        <div class="flex gap-3 rtl:gap-x-4">
          <UIButton @click="handleClick('close')">Cancel</UIButton>
          <UIButton button="primary" :disabled="isLoading">
            <span v-if="isLoading">
              <Loader />
            </span>
            <span v-else>
              {{ primaryButtonText }}
            </span>
          </UIButton>
        </div>
      </template>
    </UiModalContainer>
  </ValidationObserver>
</template>

<script>
import UiModalContainer from '@components/UiElements/UiModalContainer.vue'
import InputBox from '@components/UiElements/UiInputBox.vue'
import { mapActions } from 'vuex'
import Loader from '@components/BaseComponent/Loader.vue'
import { Form as ValidationObserver } from 'vee-validate'
import UIButton from '@src/components/UiElements/UIButton.vue'
import InputFieldWrapper from '@/src/components/UiElements/InputFieldWrapper.vue'

export default {
  components: {
    UiModalContainer,
    InputBox,
    ValidationObserver,
    Loader,
    UIButton,
    InputFieldWrapper,
  },
  props: {
    modal: {
      type: Boolean,
      default: false,
    },
    edit: {
      type: Object,
      default: () => {},
    },
  },
  emits: ['toggle'],
  data() {
    return {
      examType: {
        title: '',
        description: '',
        is_active: true,
      },
      isLoading: false,
    }
  },
  computed: {
    primaryButtonText() {
      return this.edit ? 'Update' : 'Save'
    },
  },
  created() {
    if (this.edit) this.setFormDate()
  },
  methods: {
    handleClick(eventName) {
      switch (eventName) {
        case 'close':
          this.$emit('toggle')
          break
      }
    },
    async addExamType() {
      this.isLoading = true
      let payload = { exam: this.examType }
      let res, err
      if (this.edit) payload.id = this.edit?.id
      ;[res, err] = await this.createAndUpdateExamType(payload)
      this.isLoading = false
      if (!err) this.$emit('toggle', true)
    },
    setFormDate() {
      this.examType.title = this.edit?.title || ''
      this.examType.description = this.edit?.description || ''
    },
    ...mapActions('exams', ['createAndUpdateExamType', 'getExamTypes', 'deleteExamType']),
  },
}
</script>
